import React, { useEffect } from 'react'
import CommonBanner from '../Common/CommonBanner'
import banner from "../../Assets/images/agb2.webp";
import { useDispatch } from 'react-redux';
import { setHeaderColor, setloading } from '../../Redux/ActionCreater';
import { Link } from 'react-router-dom';
const AgbPackage = () => {
  let dispatch = useDispatch()
  useEffect(() => {
    dispatch(setHeaderColor("#facee1"));
    window.scrollTo(0, 0);
    dispatch(setloading(false));
  }, [])
  return (
    <div>
      <CommonBanner slug={"agb-pakete"} />
      <section class="toppara impressumcontainer">
        <div class="container">
          <div className="row">
            <div className="col-12">
              <h4>§ 1 Geltungsbereich, Vertragssprache</h4>
              <p>(1) Die vorliegenden Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“), finden Anwendung für Leistungen,
                Bestellungen und Verträge (nachfolgend „Angebote“) in
                Zusammenhang mit der Bereitstellung von Video-Content
                aus den Bereichen Fitness und Lifestyle auf dem Online-
                Portal www.shapebysarah.com.</p>

              <p>(2) Dein Vertragspartner für Angebote, Bestellungen und
                Verträge in diesem Zusammenhang ist: SHAPE BY SARAH ECOMMERCE – FZCO, Dubai
                Silicon Oasis, DDP, Building A1/A2, Dubai, United
                Arab Emirates
                Telefon: +49170 6794214
                E-Mail: support@shapebysarah.com
                (nachfolgend „wir“).</p>
              <p>(3) Die für den Vertragsschluss zur Verfügung stehende
                Sprache ist ausschließlich Deutsch.</p>
              <h4>§ 2 Anwendbares
                Recht,
                zwingende
                Verbraucherschutzvorschriften</h4>
              <p>Es gilt das Recht der Bundesrepublik Deutschland unter
                Ausschluss des UN-Kaufrechts, wenn</p>
              <p>a) du deinen gewöhnlichen Aufenthalt in Deutschland
                hast, oder</p>
              <p>b) dein gewöhnlicher Aufenthalt in einem Staat ist, der
                nicht Mitglied der Europäischen Union ist.
                Für den Fall, dass du deinen gewöhnlichen Aufenthalt in
                einem Mitgliedsland der Europäischen Union hast, gilt
                ebenfalls die Anwendbarkeit des deutschen Rechts,
                wobei zwingende Bestimmungen des Staates, in dem du
                deinen gewöhnlichen Aufenthalt hast, unberührt bleiben.</p>
              <h4>§ 3 Leistungsumfang</h4>
              <p>1) Wir stellen eigens produzierten Video-Content für dich als
                Angebot zur Verfügung. Diese Angebote umfassen
                Video-Content aus dem Bereich Fitness in Form
                verschiedener SHAPE Programme sowie Video-Content
                aus dem Bereich Lifestyle („Sarah Time“). Dabei können
                wir dir unsere Angebote im Rahmen eines
                kostenpflichtigen Nutzungspakets und/oder im Rahmen
                einer kostenfreien Testphase zur Verfügung stellen.
                Unsere Angebote können Werbung enthalten.</p>
              <p>(2) Video-Content aus dem Bereich Fitness umfasst
                sämtliche Angebote in Zusammenhang der Themenwelt
                SHAPE Programme.</p>
              <p>(3) Video-Content aus dem Bereich Lifestyle umfasst
                sämtliche Angebote in Zusammenhang mit der
                Themenwelt „Sarah Time“. Die Bereitstellung dieser
                Angebote aus dem Bereich Lifestyle erfolgt freiwillig und
                kostenlos, somit ohne Übernahme einer Rechtspflicht.
                Wir sind jederzeit dazu berechtigt diese Angebote
                anzupassen, zu begrenzen oder zu beenden.
                Voraussetzung für eine Nutzung von Angeboten der
                Themenwelt „Sarah Time“ ist der Abschluss eines
                kostenpflichtigen Nutzungspakets und/oder einer
                kostenfreien Testphase von Video-Content aus dem
                Bereich Fitness.</p>
              <p>(4) Voraussetzung für die Nutzung aller Angebote ist deine
                Registrierung auf dem unter § 1 Ziffer 1 genannten
                Online-Portal.</p>
              <h4>§ 4 Kostenfreie Testphase</h4>
              <p>(1) Wir können dir entweder unabhängig von und vor
                Abschluss eines Vertrags über die kostenpflichtige
                Nutzung unserer Angebote oder in Verbindung mit dem
                Abschluss eines Vertrags über die kostenpflichtige
                Nutzung unsere Angebote eine kostenfreie Nutzung
                unserer Angebote im Rahmen einer Testphase anbieten.</p>
              <p>(2) Wir behalten uns das Recht vor, das Angebot einer
                derartigen kostenfreien Testphase jederzeit zu
                begrenzen oder zu beenden. Du hast keinen Anspruch
                auf die Nutzung unserer Angebote im Rahmen einer
                kostenlosen Testphase</p>
              <p>(3)Voraussetzung für die Inanspruchnahme der kostenlosen
                Testphase ist deine Registrierung auf dem unter § 1 Ziffer
                1 genannten Online-Portal.</p>
              <p>(4)Nach Ablauf der kostenlosen Testphase wird sich deine
                Mitgliedschaft automatisch zum regulären Preis des
                jeweils gewählten SHAPE-Programms verlängern, wenn
                du nicht vor Ablauf der kostenlosen Testphase deine
                Testmitgliedschaft beendest. Hierzu kannst du deine
                Testmitgliedschaft wie unter § 8 Abs. 4 dieser AGB
                beschrieben kündigen.</p>
              <h4>§ 5 Zustandekommen des Vertrags</h4>
              <p>(1) Die Darstellung der Angebote in unserem Online-Shop
                stellt kein rechtlich bindendes Angebot, sondern eine
                Aufforderung zur Bestellung („invitatio ad offerendum“)
                dar.</p>
              <p>(2) Durch Anklicken des „Zahlungspflichtig bestellen“-
                Buttons im letzten Schritt des Bestellprozesses gibst du
                ein verbindliches Angebot hinsichtlich der in der
                Bestellübersicht angezeigten Angebote ab. Zudem
                akzeptierst du durch Setzen der jeweiligen Häkchen die
                Geltung dieser AGB, der Datenschutzhinweise und
                unserer Widerrufsbelehrung.</p>
              <p>(3) Unmittelbar nach Absenden der Bestellung erhältst du
                eine automatisch versendete Bestellbestätigung per E-
                Mail, die jedoch noch keine Annahme deines
                Vertragsangebots darstellt.</p>
              <p>(4) Ein Vertrag zwischen dir und uns kommt erst zustande,
                sobald wir deine Bestellung durch eine gesonderte E-Mail
                (Auftragsbestätigung
                oder
                Versandbestätigung)
                annehmen. Bitte überprüfe regelmäßig den Spam-Ordner
                deines E-Mail-Postfachs.</p>
              <p>(5) Wir sind berechtigt, deine Bestellung nach eigenem
                Ermessen abzulehnen. Bestellungen können wir
                beispielsweise ablehnen, wenn Waren in unserem
                Online-Shop angezeigt werden, die zum Zeitpunkt deiner
                Bestellung jedoch nicht mehr verfügbar sind.</p>
              <p>(6) Erfolgt keine Annahme deiner Bestellung, werden wir dich
                per E-Mail darüber informieren, dass deine Bestellung
                nicht angenommen wurde.</p>
              <h4>§ 6 Technische Schritte bis zum Vertragsschluss und
                Berichtigung von Eingabefehlern</h4>
              <p>(1) Im Rahmen des Bestellprozesses legst du zunächst die
                gewünschten Angebote in Form der verschiedenen
                SHAPE Programme in den digitalen Warenkorb. Dort
                kannst du jederzeit die gewünschten Angebote ändern
                oder ausgewählte Angebote aus dem digitalen
                Warenkorb wieder ganz entfernen.
              </p><p>(2) Sofern du Angebote im digitalen Warenkorb hinterlegt
                hast, gelangst du durch einen Klick auf den „Zur Kasse“-
                Button auf eine Seite, auf der du deine Daten,
                insbesondere Lieferanschrift und Rechnungsadresse
                eingeben, die Zahlungsart auswählen sowie eine
                Bestellübersicht erkennen kannst.</p>
              <p>(3) Schließlich öffnet sich eine Übersichtsseite, auf der du
                deine Angaben überprüfen kannst. Deine Eingabefehler
                (z.B. bzgl. Bezahlart, Daten oder der gewünschte
                Angebote) kannst du korrigieren, indem du bei dem
                jeweiligen Feld auf „Bearbeiten“ klickst. Falls du den
                Bestellprozess komplett abbrechen möchten, kannst du
                auch einfach dein Browser-Fenster schließen. Ansonsten
                wird nach Anklicken des Buttons „Zahlungspflichtig
                bestellen“ deine Erklärung verbindlich im Sinne des § 5
                Abs. 2 dieser AGB.</p>
              <h4>§ 7 Speicherung des Vertragstextes</h4>
              <p>Die Vertragsbestimmungen mit Angaben zu den bestellten Angeboten einschließlich dieser Allgemeinen Geschäftsbedingungen und der Widerrufsbelehrung werden dir per E-Mail mit Annahme des Vertragsangebotes bzw. mit der Benachrichtigung hierüber zugesandt. Eine Speicherung der Vertragsbestimmungen durch uns erfolgt nicht.</p>
              <h4>§ 8 Vertragslaufzeit</h4>
              <p>(1)Der Vertrag über eine kostenpflichtige Nutzung unserer
                Angebote gilt für die bei Vertragsschluss vereinbarte
                Mindestlaufzeit entsprechend der verschiedenen SHAPE
                Programme.</p>
              <p>(2)Du oder wir können den Vertrag jederzeit mit einer Frist
                von einem Monat zum Ende der vereinbarten
                Mindestlaufzeit kündigen. Bis zum Ende der vereinbarten
                Mindestlaufzeit kannst du unsere Angebote nutzen.</p>
              <p>(3)Wird der Vertrag nicht zum Ende der jeweiligen
                Mindestlaufzeit gekündigt, verlängert sich die
                Vertragslaufzeit automatisch auf unbestimmte Zeit.
                Während dieser unbestimmten Laufzeit kannst du den
                Vertrag jederzeit mit einer Frist von einem Monat
                kündigen.</p>
              <p>
                (4)Deine Mitgliedschaft (Jahres- oder Monatsabo) verlängert sich nach Ablauf der Vertragslaufzeit automatisch und läuft unbefristet, wenn du nicht vorher kündigst. Nach Ablauf der Vertragslaufzeit kannst du deine Mitgliedschaft jederzeit mit einer Frist von einem Monat kündigen.
                Falls du ein Jahres-Abo gewählt hast, wandelt sich deine Mitgliedschaft nach Ablauf der Vertragslaufzeit automatisch in ein Monatspaket zum regulären Monatspreis von derzeit 24,99 € um, falls du vorher nicht kündigst.
              </p>
              <p>(5)Die Kündigung bedarf zu ihrer Wirksamkeit der Textform.
                Du kannst deine Kündigung über die Schaltfläche
                „Verträge hier kündigen“ durch Anklicken des „jetzt
                kündigen“-Buttons erklären.</p>
                <p>Du kannst <Link to='/dashboard?tab=subscription'>hier</Link> deine Mitgliedschaft kündigen.</p>
              <p>(6)Das Recht zur außerordentlichen Kündigung aus
                wichtigem Grund nach den gesetzlichen Bestimmungen
                bleibt unberührt.</p>
              <h4>§ 9 Unsere Rechte und Pflichten</h4>
              <p>(1) Wir gewährleisten dir eine regelmäßige Verfügbarkeit
                unserer Angebote. Hiervon ausgenommen sind sämtliche
                Ausfälle, Störungen oder Nichtverfügbarkeiten, die nicht
                von uns zu vertreten sind oder auf höhere Gewalt
                zurückzuführen sind.</p>
              <p>(2) Wir übernehmen keine vertraglichen Zusicherungen,
                Garantien oder Gewährleistungen, soweit nicht
                ausdrücklich etwas anderes schriftlich mit dir vereinbart
                wird.</p>
              <h4>§ 10 Deine Rechte und Pflichten</h4>
              <p>(1) Wir gestatten dir unmittelbar nach Abschluss einer kostenfreien Testphase bzw. Vertragsschluss über ein
                kostenpflichtiges SHAPE Programm den Abruf unserer Angebote räumlich beschränkt auf die Bundesrepublik
                Deutschland. [Du darfst unsere Angebote auch während eines vorübergehenden Aufenthalts in einem anderen
                EU-Mitgliedstaat ohne zusätzliche Kosten nutzen, sofern
                die Voraussetzungen der Verordnung (EU) 2017/1128
                dafür erfüllt sind. Damit wir dir den Abruf außerhalb des
                vorstehenden Gebiets ermöglichen können, prüfen wir –
                bei Bedarf auch wiederholt – ob du dich vorübergehend
                in einem anderen Land befindest. Du erklärst dich damit
                einverstanden, dass wir eine solche Überprüfung
                durchführen und dafür erforderliche Daten gemäß den
                geltenden Datenschutzbestimmungen nach § 11 Abs. 6
                dieser AGB verarbeiten.]</p>
              <p>(2) Eine Weitergabe deiner Zugangsdaten zur Nutzung
                unserer Angebote an Dritte, eine Vervielfältigung oder
                öffentliche Zugänglichmachung unserer Angebote ist –
                soweit nicht gesetzliche Bestimmungen dies ausdrücklich
                erlauben – unzulässig. Unsere Angebote sind
                ausschließlich für deinen persönlichen Gebrauch
                bestimmt.</p>
              <p>(3) Du bist dafür verantwortlich, die für die Nutzung unserer
                Angebote erforderlichen technischen Voraussetzungen
                (z.B. eine stabile Internetverbindung, geeignete Software
                zum Nutzen unserer Angebote) bereitzuhalten. Für
                Einschränkungen der Nutzbarkeit unserer Angebote, die
                auf einer Nichterfüllung dieser Pflichten beruhen, können
                wir keine Verantwortung übernehmen.</p>
              <p>(4) Wenn du schwanger bist, erkrankt bist oder an Übergewicht leidest darfst du unsere Angebote aus dem
                Bereich Fitness nur nutzen, wenn dir die Unbedenklichkeit zuvor von deinem Arzt oder deiner
                Ärztin bescheinigt wurde.</p>
              <h4>§ 11 Registrierung in unserem Online-Portal; Verarbeitung deiner personenbezogenen Daten</h4>
              <p>(1) Du bist dazu verpflichtet im Rahmen der Registrierung
                wahre und vollständige Angaben zu machen. Sollten sich
                deine Angaben während der Vertragslaufzeit ändern, bist
                du dazu verpflichtet uns deine geänderten Angaben
                unverzüglich mitzuteilen. Hierfür kannst du in deinem
                Nutzerprofil deine Angaben jederzeit anpassen.</p>
              <p>(2)Du bist dazu verpflichtet, deine Zugangsdaten geheim zu
                halten. Eine Weitergabe der Zugangsdaten sowie die
                Überlassung der Nutzmöglichkeit an andere Personen ist
                unzulässig.</p>
              <p>(3)Du darfst nur eine Registrierung gleichzeitig unterhalten.</p>
              <p>(4)Du kannst in unserem Online-Shop Angebote als Gast
                oder als registrierter Benutzer bestellen. Als registrierter
                Benutzer musst du nicht jedes Mal deine persönlichen
                Daten angeben, sondern du kannst dich vor oder im
                Rahmen einer Bestellung einfach mit deiner E-Mail-
                Adresse und dem von dir bei Registrierung frei gewählten
                Passwort in deinem Kundenkonto anmelden.</p>
              <p>(5)Allein mit deiner Registrierung besteht keinerlei
                Kaufverpflichtung hinsichtlich unserer Angebote.</p>
              <p>Für Informationen zur Verarbeitung deiner Daten lies bitte
                unsere Datenschutzinformation, die du unter folgendem
                Link <Link to={'/datenschutz'}>https://shapebysarah.com/datenschutz</Link> abrufen
                kannst.</p>
              <h4>§ 12 Preise</h4>
              <p>(1) Alle Preise in unserem Online-Shop sind in Euro (EUR)
                und verstehen sich einschließlich der jeweils gültigen
                gesetzlichen Mehrwertsteuer.</p>
              <p>(2) Es fallen keine Versandkosten an.</p>
              <p>(3) Wir behalten uns das Recht vor etwaige Preisnachlässe,
                Sonderangebote oder Rabatte jederzeit zu begrenzen
                oder zu beenden.</p>
              <h4>§ 13 Zahlungsbedingungen, Verzug</h4>
              <p>Die Bezahlung der Angebote erfolgt über einen der im
                Bestellprozess angebotenen Zahlungswege.</p>
              <p>(2) Der jeweilige Preis wird sofort mit Vertragsabschluss im
                Voraus fällig. Dasselbe gilt bei einer Vertragsverlängerung im Sinne von § 8 Abs. 3..</p>
              <p>(3) Während eines Zahlungsverzugs von dir sind wir
                berechtigt, Verzugszinsen in Höhe von 5 Prozentpunkten
                über dem Basiszinssatz (§ 247 BGB) per annum zu
                verlangen. Wir behalten uns den Nachweis eines höheren
                Schadens ausdrücklich vor. Zudem sind wir dazu
                berechtigt nach vorheriger Abmahnung und unbeschadet
                weitergehender vertraglicher und gesetzlicher Rechte,
                deinen Zugang zu unserem Online-Portal und somit
                unseren Angeboten vorübergehend zu sperren, bis wir
                deine ausstehende Zahlung erhalten haben. Eine
                derartige vorrübergehende Sperrung deines Zugangs hat
                jedoch keinen Einfluss auf die Vertragslaufzeit nach § 8
                dieser AGB.</p>
              <p>(4) Wir sind dazu berechtigt unter Einhaltung unserer Datenschutzbestimmungen
                eine individuelle Kreditwürdigkeitsprüfung durchzuführen und bestimmte
                Zahlungsmethoden auszuschließen.</p>
              <h4>§ 14 Widerrufsrecht</h4>
              <p>(1) Als Verbraucher steht dir nach Maßgabe der gesetzlichen
                Bestimmungen gemäß § 312g i.V.m. § 355 BGB ein
                Widerrufsrecht zu. Verbraucher ist jede natürliche
                Person, die ein Rechtsgeschäft zu Zwecken abschließt,
                die überwiegend weder ihrer gewerblichen noch ihrer
                selbständigen beruflichen Tätigkeit zugerechnet werden
                können.</p>
              <p>(2) Bei einem Vertrag über die Bereitstellung von nicht auf
                einem körperlichen Datenträger befindlichen digitalen
                Inhalten, also unseren Angeboten in Form von Video-
                Content, erlischt dein Widerrufsrecht, wenn wir mit der
                Ausführung des Vertrags begonnen haben, nachdem (i)
                du ausdrücklich zugestimmt hast, dass wir mit der
                Ausführung des Vertrags vor Ablauf der Widerrufsfrist
                beginnen, (ii) deine Kenntnis davon bestätigt hast, dass
                du durch deine Zustimmung mit Beginn der Ausführung
                des Vertrags dein Widerrufsrecht verlierst, und (iii) wir dir
                deine Zustimmung zur sofortigen Ausführung und die
                Bestätigung deiner Kenntnis über das Erlöschen des
                Widerrufsrechts sowie die übrigen gesetzlich
                erforderlichen Informationen in der Abschrift oder
                Bestätigung unseres Vertrages auf einem dauerhaften
                Datenträger zur Verfügung gestellt haben.</p>
              <h4>§ 15 Haftungsbeschränkung</h4>
              <p>(1) Wir haften für Vorsatz und grobe Fahrlässigkeit. Ferner
                haften wir für die fahrlässige Verletzung von Pflichten,
                deren Erfüllung die ordnungsgemäße Durchführung des
                Vertrags überhaupt erst ermöglicht, deren Verletzung die
                Erreichung des Vertragszweckes gefährdet und auf deren
                Einhaltung du als Kunde regelmäßig vertrauen darfst. Im
                letztgenannten Fall haften wir jedoch nur für den
                vorhersehbaren, vertragstypischen Schaden. Gleiches
                gilt für Pflichtverletzungen unserer Erfüllungsgehilfen.</p>
              <p>(2) Die vorstehenden Haftungsausschlüsse gelten nicht bei
                Verletzung von Leben, Körper und Gesundheit. Die
                Haftung nach dem Produkthaftungsgesetz bleibt
                unberührt.</p>
              <h4>§ 16 Urheberrechte</h4>
              <p>Wir haben an allen Bildern, Filmen und Texten, die in unserem
                Online-Portal veröffentlicht werden, Urheberrechte. Eine
                Verwendung der Bilder, Filme und Texte ist ohne unsere
                ausdrückliche Zustimmung nicht gestattet.</p>
              <h4>§ 17 Schlussbestimmungen</h4>
              <p>(1) Sollten einzelne Bestimmungen dieses Vertrags
                unwirksam sein, so wird hierdurch der Vertrag im Übrigen
                nicht berührt. An die Stelle der unwirksamen Bestimmung
                treten, soweit vorhanden, die gesetzlichen Vorschriften.</p>
              <p>(2) Zur Teilnahme an einem Streitbeilegungsverfahren nach
                dem Verbraucherstreitbeilegungsgesetz (VSBG) sind wir
                nicht verpflichtet und nicht bereit.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default AgbPackage